<ion-content *ngIf="(lotes$ | async) && (mapa$ | async)" [scrollY]="false">
  <usucampeao-lote-selecionar [cadastroId]="cadastroId" [lotes]="lotes$ | async" [mapa]="mapa$ | async" (aoSelecionarLote)="selecionarLote($event)"></usucampeao-lote-selecionar>
</ion-content>
